import Box from "@mui/material/Box";

const FieldBlock = ({ children }) => (
  <Box
    sx={{
      marginBottom: "18px",
    }}
  >
    {children}
  </Box>
);

export default FieldBlock;
